<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>ダッシュボード</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h4>請求書一括作成</h4>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <v-btn
          class="title-btn mr-4"
          @click="getInvoiceQueue"
        >
          更新
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="invoiceheaders"
          :items="invoiceitems"
          :server-items-length="invoiceitem_total"
          :loading="invoiceloading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getInvoiceQueue"
        >
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h4>配送データ一括作成</h4>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <v-btn
          class="title-btn mr-4"
          @click="getShippingQueue"
        >
          更新
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="shippingitems"
          :server-items-length="shippingitem_total"
          :loading="shippingloading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getShippingQueue"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      invoiceheaders: [
        {text: "作成日時", value: "created_at"},
        {text: "作成者", value: "created_by"},
        {text: "請求日", value: "date_of_issue"},
        {text: "ステータス", value: "status"},
        {text: "対象購読件数", value: "total_count"},
        {text: "作成件数", value: "execute_count"},
      ],
      headers: [
        {text: "作成日時", value: "created_at"},
        {text: "作成者", value: "created_by"},
        {text: "対象商品", value: "deliveryitemdetail.name"},
        {text: "ステータス", value: "status"},
        {text: "対象購読件数", value: "total_count"},
        {text: "作成件数", value: "execute_count"},
      ],
      invoiceitems: [],
      shippingitems: [],
      params: {
        deliveryitemcategory: '',
        name: '',
      },
      invoiceloading: false,
      shippingloading: false,
      invoiceitem_total: 0,
      shippingitem_total: 0,
      options: {
        itemsPerPage: 5,
      },
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
    }
  },
  created() {
  },
  methods: {
    async getShippingQueue() {
      this.shippingloading = true;
      try {
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/shippingqueue/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.shippingitem_total = response.data.count
        this.shippingitems = response.data.results
        this.shippingloading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.shippingloading = false;
      }
    },
    async getInvoiceQueue() {
      this.invoiceloading = true;
      try {
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/invoicequeue/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.invoiceitem_total = response.data.count
        this.invoiceitems = response.data.results
        this.invoiceloading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.invoiceloading = false;
      }
    },
  },
}
</script>